import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from "../grid.base.case";
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HandleServerContextAfterDBRequest, HandleWebParameterContextBeforeDBRequest } from '../../../../bizlogic/servicesbll';
import { CommonService} from '../../../../service/common.service';
declare var app;
@Component({
  selector: 'app-mz-grid-list-icon1',
  templateUrl: './mz-grid-list-icon1.component.html',
  styleUrls: ['./mz-grid-list-icon1.component.scss']
})
export class MzGridListIcon1Component extends GridBaseCase {
  dataArrayList: Array<any> = [];
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    public com:CommonService
  ) { super(); }

  LoadData() {
    const that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body: WebParameterContext = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.Name = pageName;
    body.Client.PageName = pageName;
    // if (that.platform.is("android")) {
    //   body.Client.ClientType = 0;
    // } else if (that.platform.is("ios")) {
    //   body.Client.ClientType = 1;
    // }
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      data = HandleServerContextAfterDBRequest(body, data);
      
        that.dataArrayList = [];
        if (data.ResponseMessage.Success) {
          
          data.Status.Datas.forEach(function (item) {
            let objfield = {};
            that.element.selectItemList.selectItem.forEach((element, index) => {
              if(element.bindingField){
                objfield[element.bindingField] = decodeURI(item[element.field]);
              }
              if (element.bindingField == 'date' && item[element.field]) {
                objfield[element.bindingField] = item[element.field].replace('00:00:00','');
              }
            });
            that.dataArrayList.push(objfield);
          });
          
        } else {
          console.log(data.ResponseMessage.ErrorMessage);
        }

        // data.Status.Datas.forEach(function (item) {
        //   let newsItem = {
        //     id: item[that.newsItem['idKey']] || '',
        //     title: item[that.newsItem['titleKey']] || '',
        //     time: item[that.newsItem['timeKey']] || '',
        //     author: item[that.newsItem['authorKey']] || '',
        //     rightIcon: item[that.newsItem['rightIconKey']] || ''
        //   }
        //   that.gridDataList.push(newsItem);
        // })
      
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  /**
  * 下拉刷新数据
  * @param event
  */
  doRefresh(event) {
    this.LoadData();
    event.target.complete();
  }
  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        console.log(evs, parms);
      } else { 
        localStorage.setItem('element', JSON.stringify(ev));
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/" +ev.selectItemList.gridViewConfigName+"/"+ parms.id);
        this.com.Go(evs + "/" +ev.selectItemList.gridViewConfigName+"/"+ parms.id);
      }
    }
  }

}
